export const ESTADOS_MX = [
  "Aguascalientes", "Baja California", "Baja California Sur", "Campeche", "Chiapas",
  "Chihuahua", "CDMX", "Coahuila", "Colima", "Durango", "Estado de México", "Guanajuato",
  "Guerrero", "Hidalgo", "Jalisco", "Michoacán", "Morelos", "Nayarit", "Nuevo León",
  "Oaxaca", "Puebla", "Querétaro", "Quintana Roo", "San Luis Potosí", "Sinaloa", "Sonora",
  "Tabasco", "Tamaulipas", "Tlaxcala", "Veracruz", "Yucatán", "Zacatecas",
];

export const ESTADO_FLUJO = {
  borrador_ia: { label: "Borrador", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  en_revision: { label: "En revisión", cls: "bg-[#FEF3C7] text-[#92400E] border-[#FCD34D]" },
  aprobado_legal: { label: "Aprobado legal", cls: "bg-[#E0ECF8] text-[#1E3A5F] border-[#9DB9D8]" },
  publicado: { label: "Publicado", cls: "bg-[#ECFDF5] text-[#047857] border-[#A7F3D0]" },
};

export const EJEMPLO_JSON = `[
  {
    "document": "arrendamiento_habitacional",
    "fields": ["campo_de_ejemplo"],
    "title": "¿Por qué pedir depósito en garantía?",
    "body": "Cómo sí: texto revisado por tu equipo legal…",
    "dudas": "Dudas reales de asesores y su respuesta…",
    "source": "Art. 2448-D CCDMX",
    "jurisdiccion": "CDMX",
    "url_contenido": "https://youtu.be/xxxx",
    "estado": "en_revision"
  },
  {
    "document": "arrendamiento_habitacional",
    "fields": ["campo_de_ejemplo"],
    "title": "¿Por qué pedir depósito en garantía? (Jalisco)",
    "body": "Versión para Jalisco…",
    "source": "Código Civil del Estado de Jalisco",
    "jurisdiccion": "Jalisco"
  }
]`;

export const EJEMPLO_FAQ_JSON = `[
  {
    "pregunta": "¿Quién paga el ISR en una compraventa?",
    "respuesta": "Respuesta revisada por tu equipo fiscal…",
    "categoria": "Fiscal",
    "fuente": "LISR",
    "jurisdiccion": "Nacional"
  },
  {
    "pregunta": "¿Cuánto tarda la inscripción en el Registro Público?",
    "respuesta": "Respuesta para CDMX…",
    "categoria": "Registro",
    "jurisdiccion": "CDMX",
    "estado": "en_revision"
  }
]`;
